<div [className]="disableUI?.value ? 'disabled container' : 'container'">
    <div [formGroup]="educationChild">
        <h3>{{TITLE}}</h3>
        <div class="ecc">
            <!-- residency - speciality -->
            <div class="row FlowupLabels" *ngIf="accountType == AccountType.RESIDENCY && ui_Speciality != null">
                <div class="col-md-12">
                    <div class="validationwrap"
                        [class.validation-error]="specialityid.invalid && (specialityid.dirty || specialityid.touched || formSubmitted)">
                        <div class="fl_wrap">
                            <label class="fl_label">Speciality</label>

                            <select class="fl_input" FlowUpLabel formControlName="specialityid">
                                <option value=""></option>
                                <option *ngFor="let obj of ui_Speciality" [value]="obj.id">{{obj.acep_name}}</option>
                            </select>

                            <span class="validationhead">
                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- residency - speciality -->


            <!-- certification board-->
            <div class="row FlowupLabels" *ngIf="accountType == AccountType.BOARDCERTIFICATION">
                <div class="col-md-12">
                    <div class="validationwrap"
                        [class.validation-error]="boardcertificationid.invalid && (boardcertificationid.dirty || boardcertificationid.touched || formSubmitted)">
                        <div class="fl_wrap">
                            <label class="fl_label">Board Certification</label>
                            <select class="fl_input" FlowUpLabel formControlName="boardcertificationid">
                                <option value=""></option>
                                <option *ngFor="let obj of ui_BoardCertifications" [value]="obj.accountId">{{obj.name}}
                                </option>
                            </select>
                            <span class="validationhead">
                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required</span>

                        </div>
                    </div>
                </div>
            </div>
            <!-- certification board -->


            <app-account-lookup *ngIf="accountType != AccountType.BOARDCERTIFICATION"
                [isInternational]="isInternational" [accountLookUp]="accountLookUp" [accountType]="accountType"
                (onSelect)="onAccountSelected($event)"></app-account-lookup>
            <app-address *ngIf="showAddress" [address]="address"></app-address>
            <app-grad-date [graduation]="graduation"
                [TITLE]="accountType != AccountType.BOARDCERTIFICATION? 'Graduation' : 'Certification'"></app-grad-date>
        </div>
    </div>
</div>